import React from "react";
import { Checkbox, TextField } from "@mui/material";
import { inlineChoiceControlSx } from "../../../common/dashboard/formStyles";
import { invoiceFieldSx } from "../../Invoicing/InvoiceDesignSystem";

// Design (11) Create Ticket Invoice "Tax Exempt" box (CMP Dashboard 3767-3781):
// the box turns gold when checked and reveals the optional exemption number.
const EventTicketTaxExemptBox = ({
  disabled,
  exempt,
  number,
  onExemptChange,
  onNumberChange,
}: {
  disabled?: boolean;
  exempt: boolean;
  number: string;
  onExemptChange: (exempt: boolean) => void;
  onNumberChange: (number: string) => void;
}) => (
  <div
    className={`flex flex-col gap-3 rounded-lg border px-4 py-[14px] ${
      exempt ? "border-[#E1A731] bg-[#FDF8EE]" : "border-[#ECECEC] bg-white"
    }`}
  >
    <label className="flex items-start gap-[10px]">
      <Checkbox
        checked={exempt}
        className="mt-[2px]"
        disabled={disabled}
        onChange={({ target }) => onExemptChange(target.checked)}
        sx={inlineChoiceControlSx}
      />
      <span className="flex flex-col gap-[2px]">
        <span className="text-[14px] font-semibold leading-[normal] text-[#0A0A0A]">
          Tax Exempt
        </span>
        <span className="text-[14px] leading-[normal] text-[#0A0A0A]">
          Check this box if the customer is tax exempt. Tax will not be charged
          on any ticket on this invoice.
        </span>
      </span>
    </label>
    {exempt ? (
      <div className="flex max-w-[360px] flex-col gap-1.5 pl-7">
        <label
          className="text-[14px] font-semibold leading-[normal] text-[#0A0A0A]"
          htmlFor="ticket-invoice-tax-exemption-number"
        >
          Tax Exemption Number (Optional)
        </label>
        <TextField
          disabled={disabled}
          id="ticket-invoice-tax-exemption-number"
          inputProps={{ maxLength: 50 }}
          onChange={({ target }) => onNumberChange(target.value)}
          placeholder="Enter Tax Exemption Number"
          size="small"
          sx={invoiceFieldSx}
          value={number}
        />
      </div>
    ) : null}
  </div>
);

export default EventTicketTaxExemptBox;
